import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { readWrite } from '../../user/user-permission/user-permission.data';
import { UserPermissionService } from '../../user/user-permission/user-permission.service';
import { LogGroupByOption, LogQueryParams, LogGroupQueryResult } from '../log.model';
import { LogService } from '../log.service';

@UntilDestroy()
@Component({
    selector: 'ifb-log-grouped-list',
    templateUrl: './log-grouped-list.component.html',
    styleUrls: ['./log-grouped-list.component.scss'],
    standalone: false
})
export class LogGroupedListComponent implements OnInit {
  data: LogGroupedComponentData;
  queryParams: any;
  canReadWriteLog = false;
  tableColumns: string[] = ['group'];

  @Input()
  activeGroupBy: LogGroupByOption;

  @Output()
  showMessagesSelected = new EventEmitter<LogQueryParams>();

  @Output()
  archived = new EventEmitter<any>();

  constructor(
    private route: ActivatedRoute,
    private logService: LogService,
    private userPermissionService: UserPermissionService) {
  }

  ngOnInit(): void {
    this.route.data.pipe(untilDestroyed(this))
      .subscribe((it: LogGroupedComponentData) => this.data = it);

    this.route.queryParams.pipe(untilDestroyed(this))
      .subscribe(it => { this.queryParams = it; });

    this.userPermissionService.granted([readWrite('admin-logs')])
      .subscribe(res => this.canReadWriteLog = res);
  }

  private getQueryParams(groupName: string, groupId: string): LogQueryParams {
    const params: LogQueryParams = {};
    params.groupBy = undefined;

    if (this.activeGroupBy === LogGroupByOption.ExceptionType || this.activeGroupBy === LogGroupByOption.ExceptionTargetSite)
      params.exceptionHashCode = groupId;
    else params[this.activeGroupBy] = groupName;

    return Object.assign({}, this.queryParams, params);
  }

  archive(groupName: string, groupId: string): void {
    const params = this.getQueryParams(groupName,groupId);
    this.logService.archiveAll(params).subscribe(() => {
      this.archived.emit();
    });
  }

  showLogMessages(groupName: string, groupId: string): void {
    const params = this.getQueryParams(groupName, groupId);
    this.showMessagesSelected.emit(params);
  }
}

export interface LogGroupedComponentData {
  logGroupQueryResult?: LogGroupQueryResult;
}
